import React, { useState, useEffect } from "react";
import { Modal, Descriptions, Tag, Typography } from "antd";
import { getBelt, ListClass } from "../../constants/API/API";
import { ShowToast, Severty } from "../../helper/toast";
import useApi from "../../hooks/useApi";

const { Title } = Typography;

const KyuView = ({ viewVisible, setViewVisible, selectedKyu }) => {
  const [kyuData, setKyuData] = useState(selectedKyu || {});
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);

  // useApi({
  //   callback: ListClass,
  //   dependencies: [],
  //   shouldCallApi: true,
  //   onSuccess: ({ list }) => setClasses(list),
  // });

  // useEffect(() => {
  //   if (selectedBelt) {
  //     setLoading(true);
  //     getBelt(selectedBelt._id)
  //       .then((response) => {
  //         if (response.status === 200 && response.data) {
  //           setKyuData(response.data);
  //         }
  //       })
  //       .catch((err) => {
  //         ShowToast(err.message || "Failed to fetch belt data", Severty.ERROR);
  //       })
  //       .finally(() => setLoading(false));
  //   }
  // }, [selectedBelt]);

  const handleCancel = () => {
    setViewVisible(false);
    setKyuData(null);
  };

  const getClassName = (classId) => {
    const cls = classes.find((c) => c._id === classId);
    return cls ? cls.name : "-";
  };

  console.log("kyuData", kyuData);

  return (
    <Modal
      open={viewVisible}
      title={<Title level={4} style={{ margin: 0 }}>Kyu Details</Title>}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
      loading={loading}
    >
      {kyuData && (
        <Descriptions
          bordered
          column={1}
          labelStyle={{
            fontWeight: 500,
            backgroundColor: "#fafafa",
            minWidth: "150px",
          }}
          contentStyle={{
            backgroundColor: "#fff",
          }}
        >
          <Descriptions.Item label="Kyu Name">
            {kyuData?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Belt">
            {kyuData?.belt?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Classes Required">
            {kyuData?.requiredClasses}
          </Descriptions.Item>
          <Descriptions.Item label="Priority Number">
            {kyuData?.priorityNumber || "N/A"}
          </Descriptions.Item>
          {/* <Descriptions.Item label="Always Eligible">
            {kyuData?.alwaysEligible ? "Yes" : "No"}
          </Descriptions.Item> */}
          <Descriptions.Item label="Trigers Graduation Eligibility">
            {kyuData?.triggersGraduationEligibility ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="UID">
            <Tag style={{ fontFamily: "monospace" }}>{kyuData._id}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={kyuData.isActive ? "success" : "error"}>
              {kyuData.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>
             <Descriptions.Item label="Kyu description">
            {kyuData?.description}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
};

export default KyuView;